
<template>
  <div class="verify-coupon">
    <template v-if="!coupon">
      <div class="tips">无效的优惠券</div>
    </template>
    <template v-else-if="!hasScope">
      <div class="tips">您无权限核销此优惠券，请联系管理员</div>
    </template>
    <template v-else>
      <div class="info general-box-shadow">
        <div class="info-title">优惠券信息</div>
        <div class="trade-offline-info noboder">
          <div class="offline-info-item">
            <div class="info-field-name">优惠券码:</div>
            <div>{{ distribute.couponCode }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">优惠券类型:</div>
            <div>{{ coupon.typeName }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">适用店铺:</div>
            <div>{{ shopScopes }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">优惠券来源:</div>
            <div>{{ distribute.originName }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">状态:</div>
            <div>{{ distribute.statusName }}</div>
          </div>
          <template v-if="distribute.status ==='1'">
            <div class="offline-info-item">
              <div class="info-field-name">核销时间:</div>
              <div>{{ distribute.useTime | shortTime }}</div>
            </div>
            <div class="offline-info-item">
              <div class="info-field-name">核销店铺:</div>
              <div>{{ distribute.verifyShop.name }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="info general-box-shadow">
        <div class="info-title">会员信息</div>
        <div class="trade-offline-info noboder">
          <div class="offline-info-item">
            <div class="info-field-name">会员昵称:</div>
            <div>{{ distribute.user.decodeNickname }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">手机号:</div>
            <div>{{ wrapperPhone(distribute.user.phone) }}</div>
          </div>
          <div class="offline-info-item">
            <div class="info-field-name">注册时间:</div>
            <div>{{ distribute.user.regTime | shortTime }}</div>
          </div>
        </div>
      </div>
      <div class="offline-btn-group" v-if="distribute.status === '0'">
        <div class="general-btn submit-btn" @click = "handleVerifyCoupon">核销</div>
      </div>
    </template>
  </div>
</template>

<script>
  import {MessageBox, Toast} from 'mint-ui'
  import session from '../utils/Session'
  import userService from '../service/customer/UserService'
  import shopService from '../service/shop/ShopService'
  import verifierService from '../service/shop/VerifierService'
  import dealerCouponService from '../service/shop/DealerCouponService'
  import Header from "@/components/header/Header.vue";


  const param = [];
  param.push('appid=wxedd0b298e08a1998');
  param.push('redirect_uri='+encodeURIComponent('https://xyz.shuimujiaju.com/callback/index_v2.html?v=1'));
  param.push('response_type=code');
  param.push('scope=snsapi_base');
  // param.push('state=' + '{\'redirectUrl\': \''+ window.location.href +'\'}');
  param.push('state=' + encodeURIComponent(window.location.href));
  const redirectUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?' + param.join('&');
  // const redirectUrl = 'https://open.weixin.qq.com/connect/qrconnect?' + param.join('&');

  export default {
  name: 'VerifyCoupon',
  components: {
    'my-header': Header,
  },
  data: function () {
    return {
      couponCode: '',
      shop: {},
      verifier: null,
      coupon: null,
      distribute: null,
      success: false,
      isWechatBrowser:this.$verfyBrowserType(),
    }
  },
  created() {
    window.document.title = '核销优惠券'
    this.auth();
  },
  beforeMount () {
    if (this.$route.query) {
      this.couponCode = this.$route.query.couponCode || ''
      this.loadCoupon()
    }
  },
  computed: {
    shopScopes() {
      if (this.distribute) {
        const { shops } = this.distribute
        if(shops && shops.length > 0) {
          return shops.map(shop => shop.name).join('|')
        } else {
          return '无限制'
        }
      }
      return ''
    },
    hasScope() {
      return true
    }
  },
  methods: {
    wrapperPhone(phone) {
      if (phone) {
        return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return ''
    },
    loadCoupon() {
      if (this.couponCode) {
        dealerCouponService.detail(this.couponCode).then(result => {
          if (result.data) {
            this.distribute = result.data || {}
            this.coupon = this.distribute.coupon || {}
          } else {
            MessageBox.confirm('参数错误')
          }
          console.log('coupon==============', result)
        })
      }
    },
    async auth () {
      if (session.verifierIsLogin()) {
        this.verifier = session.getVerifier() || null
        return
      }
      let code = this.$route.query.code;
      console.log('code=====', code)
      if(!code && !session.verifierIsLogin()){
        window.location.href = redirectUrl;
        console.log('code=====刷新页面')
        return
      }
      if(code){
        console.log('code=====login', code)
        const result = await verifierService.login(code);
        console.log('code=====login-res', result)
        if (result.code === '0') {
          //登录成功
          session.setVerifier(result.data);
          this.verifier = result.data
          const newUrl = window.location.href.replace(/\&code=.*/, '');
          console.log('code=====newUrl', newUrl)
          window.location.href = newUrl
        } else {
          MessageBox.confirm('对不起，您的授权操作失败,请您重新授权!').then((action) => {
            window.location.href = redirectUrl;
          }).catch(e => {
            window.location.href = redirectUrl;
          });
        }
      }
    },
    handleVerifyCoupon() {
      if (!this.couponCode) {
        Toast('参数错误');
        return
      }
      if (!this.verifier || !this.verifier.id) {
        Toast('您未登录');
        return
      }
      const message = `确定核销此优惠卷吗？`
      MessageBox.confirm(message).then((action) => {
        console.log('confirm====', action)
        return dealerCouponService.verifyCoupon({
          couponCode: this.couponCode,
          verifierId: this.verifier.id
        })
      }).then(regRes => {
        console.log('confirm====', regRes)
        if (regRes.code === '0') {
          this.success = !!regRes.data
          this.loadCoupon()
        } else {
          Toast(regRes.msg)
        }
      }).catch(e => {
        console.log('confirm====', e)
      });
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/common.scss';
.verify-coupon {
  height: 100vh;
  margin-top: -1rem;
  background: white;
  font-size: 0.32rem;
  .tips {
    width: 100%;
    text-align: center;
    padding-top: 2rem;
  }
  .info{
    width: 6.90rem;
    margin: 0.3rem 0.2rem 0 0.3rem;
    .info-title {
      position: relative;
      font-size: 0.34rem;
      color: #333;
      padding: 0.2rem 0.2rem 0;
      font-weight: 600;
      &:after {
        position: absolute;
        bottom: -0.15rem;
        left: 0;
        content: '';
        display: block;
        width: 100%;
        height: 0.01rem;
        background-color: #eee;
      }
    }
  }
  .trade-offline-info {
    &.noboder {
      //border: none !important;
      &:last-child {
        border: none !important;
      }
    }
    .offline-info-item {
      &+.offline-info-item {
        margin-top: 0.2rem;
      }
    }
    .info-field-name {
      width: 1.8rem;
      flex-shrink: 0;
      flex-grow: 0;
    }
  }
  .offline-btn-group{
    display: flex;
    justify-content: flex-end;
    padding: .3rem;
    //margin-top: 0.42rem;
    //margin-right: 0.6rem;
  }
  .general-btn{
    width: 100%;
    //margin-left: 0.2rem;
  }
  .submit-btn {
    color: white;
    margin-top: 1rem;
    bottom: 0.3rem;
    left: 0.34rem;
    width: 6.82rem;
    height: 1rem;
    line-height: 1rem;
    border-radius: 0.1rem;
    background-color: #00478e;
    text-align: center;
    letter-spacing: 2px;
    font-weight: 600;
  }
}
</style>
